var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBArrowsOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-arrows-expand",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-arrows-expand1",
    serifid: "iconB-arrows-expand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.314,11l-2.536,-2.536c-0.39,-0.39 -0.39,-1.023 0,-1.414c0.39,-0.39 1.024,-0.39 1.414,0l4.243,4.243c0.19,0.19 0.293,0.444 0.293,0.707c-0,0.263 -0.103,0.517 -0.293,0.707l-4.243,4.243c-0.39,0.39 -1.024,0.39 -1.414,-0c-0.39,-0.391 -0.39,-1.024 0,-1.414l2.536,-2.536l-6.486,0c-0.551,0 -1,-0.448 -1,-1c0,-0.552 0.449,-1 1,-1l6.486,0Zm-19.749,0.293l4.243,-4.243c0.39,-0.39 1.024,-0.39 1.414,0c0.39,0.391 0.39,1.024 -0,1.414l-2.536,2.536l6.486,0c0.551,0 1,0.448 1,1c-0,0.552 -0.449,1 -1,1l-6.486,-0l2.536,2.536c0.39,0.39 0.39,1.023 -0,1.414c-0.39,0.39 -1.024,0.39 -1.414,-0l-4.243,-4.243c-0.19,-0.19 -0.293,-0.444 -0.293,-0.707c0,-0.263 0.103,-0.517 0.293,-0.707Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBArrowsOut);
export default __webpack_public_path__ + "static/media/iconB-arrows-out.c92c0d3e3d2a1b3a70d8a9d8d5dd70ca.svg";
export { ForwardRef as ReactComponent };